import styles from "./smart.module.css";
import { useRef, useEffect } from "react";
import parallax from "../parallax";
import DOMPurify from "dompurify";

const Smart = ({ textData, language }) => {
  const textBox = useRef(null);
  useEffect(() => {
    parallax(
      {
        trigger: textBox.current,
        start: "top bottom",
        end: "top top",
        scrub: true,
      },
      textBox.current
    );
  }, []);
  return (
    <div className={styles.ctn}>
      <div className={styles.imgBox1} data-parallax="true">
        {language === "cn" ? (
          <video
            autoPlay
            loop
            playsInline
            muted
            preload="true"
            src={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-12${
              language === "cn" ? "" : "-en"
            }.mp4`}
            poster={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-12-poster${
              language === "cn" ? "" : "-en"
            }.jpg`}
          ></video>
        ) : (
          <img
            src={`https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-12-poster${
              language === "cn" ? "" : "-en"
            }.jpg`}
          />
        )}
      </div>

      <div className={styles.textBox} ref={textBox}>
        <h2
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text23"]),
          }}
        ></h2>

        <h5
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(textData["text24"]),
          }}
        ></h5>
      </div>

      {/* <div className={styles.imgBox2} data-parallax="true">
        <img src="https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-13.jpg" alt="" />
      </div>

      <div className={styles.imgBox3} data-parallax="true">
        <img src="https://bucket.zhiyun-tech.com/detail/smq4/smq4-detail-media-14.jpg" alt="" />
      </div> */}
    </div>
  );
};

export default Smart;
